import { render, staticRenderFns } from "./WidgetTestimonials.vue?vue&type=template&id=75737bd5"
import script from "./WidgetTestimonials.vue?vue&type=script&lang=js"
export * from "./WidgetTestimonials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports